import React from "react";
import useGames from "../../hooks/queryResults/useGames";
import useIsLoading from "../../hooks/queryResults/useIsLoading";
import useTeam from "../../hooks/queryResults/useTeam";
import useTeams from "../../hooks/queryResults/useTeams";
import useWeek from "../../hooks/queryResults/useWeek";
import Box from "../layout/Box";
import Loading from "../ui/Loading";
import TeamLineupPage from "./TeamLineupPage";
import TeamTransactions from "./TeamTransactions";

const TeamHome = () => {
  const { team, teamsQuery } = useTeam();

  const isLoading = useIsLoading(team, teamsQuery);
  if (isLoading) return <Loading />;

  return (
    <div>
      <TeamLineupPage />
      <Box title={"transactions"} style={{ marginTop: "2rem" }}>
        <TeamTransactions team={team} />
      </Box>
    </div>
  );
};

export default TeamHome;
